import { CreateButton } from "@/components/admin";
import { useTranslate } from "ra-core";
import useAppBarHeight from "../misc/useAppBarHeight";
import { ContactImportButton } from "./ContactImportButton";

export const ContactEmpty = () => {
  const appbarHeight = useAppBarHeight();
  const translate = useTranslate();
  return (
    <div
      className="flex flex-col justify-center items-center gap-3"
      style={{
        height: `calc(100dvh - ${appbarHeight}px)`,
      }}
    >
      <img src="./img/empty.svg" alt={translate("simplecrm.contacts.no_contacts_found")} />
      <div className="flex flex-col gap-0 items-center">
        <h6 className="text-lg font-bold">{translate("simplecrm.contacts.no_contacts_found")}</h6>
        <p className="text-sm text-muted-foreground text-center mb-4">
          {translate("simplecrm.contacts.empty_list_message")}
        </p>
      </div>
      <div className="flex flex-row gap-2">
        <CreateButton label={translate("simplecrm.contacts.new_contact")} />
        <ContactImportButton />
      </div>
    </div>
  );
};
